import { FC } from 'react';
import { ModalProps, ButtonProps } from 'antd';
import { FloatingButton, CloseIcon, Modal, Title } from './styled';

export interface BaseSecuritiesModalProps extends ModalProps {
  submitText?: string;
  onSubmit?(): void;
  submitProps?: ButtonProps;
  hideSubmit?: boolean;
  modalWidth?: number;
}

const BaseSecuritiesModal: FC<BaseSecuritiesModalProps> = ({
  title,
  submitText,
  onSubmit,
  submitProps,
  hideSubmit,
  children,
  modalWidth = 500,
  ...props
}) => (
  <Modal
    width={modalWidth}
    footer={null}
    closeIcon={<CloseIcon />}
    centered
    {...props}
  >
    {title && <Title>{title}</Title>}
    {children}
    {!hideSubmit && (
      <FloatingButton type="primary" onClick={onSubmit} {...submitProps}>
        {submitText}
      </FloatingButton>
    )}
  </Modal>
);

export default BaseSecuritiesModal;
